import React, { useState, useEffect,useMemo } from 'react';
import { Grid, Box,Typography, Button,useMediaQuery ,useTheme} from '@mui/material';
// import { Formik, Form, } from 'formik';
// import FormikControl from '../../../../components/FormikControls/FormikControl';
// import DyButton from /'../../../../components/GlobalComponents/DyButton/DyButton';
// import { currentStateActionsOptions, iSchema, nextStateActionOptions } from '../../StataicData';
import { useAddCommitments, useGetAllCommitments, useGetCommitMeetingHistory } from '../../Hooks/index';
import { useSelector } from 'react-redux';
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom1/DYCustom2';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import CreateKrAction from './CreateKrAction';
// import { useGetAllActivePersonByTenantId, useGetAllObjectiveOKRStateByTenantId } from '../../../OKRManagment/Hooks';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import { GridCheckCircleIcon } from '@mui/x-data-grid';
import { CreateCommitments } from './CreateCommitments';

const  RelatedKrAction = ({cancelo, kresultId,onsucces,pointingSystem,afterAddKr,objective,krDetail,rowSelectedData }: any) => {
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
  const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
  const priodName = useSelector((state: any) => state.meetings.periodName);
  const theme = useTheme();
  const { mutate: addCheck, data:addCheckingData, isSuccess,isLoading } = useAddCommitments();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // برای موبایل حالت بسته می‌شود

  const [krId, setKrId] = useState('');
  const {data:historyData,isLoading:historyDataLoading,refetch: getAgain1}:any=useGetAllCommitments(kresultId,priodId);
//   const {
//     data: KrHistoryData,
//     isLoading: KRHLoading,
//     isError: KRHError,
//     isFetched: KRHFetched,
//   } = useGetCommitMeetingHistory(meetingId, kresultId);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [createTenantModal, setCreateTenantModal] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [showToastMessage1, setShowToastMessage1] = useState<any>(false);
  const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
  const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
    localStorage.getItem("indexSelectionModel")
  );
  const [Ids, setIds] = useState(null);
  const [krRowData, setKrRowData] = useState<any>(null);

//   const { data: submitOptions } =
//   useGetAllObjectiveOKRStateByTenantId(tenantId);
//   const { data: personsOptionds } = useGetAllActivePersonByTenantId(tenantId);
  const addCheckinSuccess = () => {
    afterAddKr()
    cancelo()
    onsucces(true)

  }
//   const [renderState, setRenderState] = useState<string>('add');
  const [okrStateId, setOkrStateId] = useState<string>("");
  const initialCancel = (): void => {
    cancelo()
  }
  
  const[krDetailSps,setKrDetailSps]=useState<any>(null);

  useEffect(() => {
    if (krDetail && objective ) {
      let{name}=krDetail;
      let{name:objectiveName}=objective;
      let details:any={
        krName:name,
        objectiveName:objectiveName,
        priodName:priodName
      }
      setKrDetailSps(details)
    }
  }, [krDetail,objective])

  const[initialValuesForm,setInitialValuesForm]=useState<any>({description:''});
  const [historyModal, setHistoryModal] = useState(false);

  const initialCreateMeeting=()=>{
    setCreateTenantModal(!createTenantModal)
   }

  useEffect(() => {
  if (rowSelectedData) {
    let{description,problems,predict,currentStateValue}=rowSelectedData;
    setInitialValuesForm((prev:any)=>({description:description,problems:problems,nextState:predict,currentState:currentStateValue}))
  }
  }, [rowSelectedData])
  
  const evaluationData: any = {
    meetingId: meetingId,
    teamId: teamId,
    periodId: priodId,
    tenantId: profileTenantId,
    text: '',
    description: '',
    personId: '',
    commitmentsPriority: '',
    commitmentsStatus: '',
    startDate: null, // مقادیر تاریخ
    startTime: null, // مقادیر ساعت
    duedate: null,
    dueTime: null,
  }

  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 5,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
    { field: 'text',
        align:'center',
        headerName: 'شرح',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90,
         flex: 0.5,
        },
      { field: 'personName',
        align:'center',
        headerName: ' مسئول',
        headerAlign:'center',
        sortable:false,
        width:90,
        wrap:'wrap',
      },
      { field: 'commitmentsPriority',
      align:'center',
      headerName: 'اولویت',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
       width:90
      },
      { field: 'commitmentsStatus',
        align:'center',
        headerName: 'وضعیت',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90,
      },
      { field: 'startDate',
        align:'center',
        headerName: 'تاریخ شروع',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
      },
      { field: 'startTime',
        align:'center',
        headerName: 'زمان شروع',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
      },
      { field: 'dueDate',
        align:'center',
        headerName: 'تاریخ مقرر',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
      },
      { field: 'dueTime',
        align:'center',
        headerName: 'زمان مقرر',
        headerAlign:'center',
        sortable:false,
        wrap:'wrap',
         width:90
      }
      ,{
        field: "Evaluation",
        headerName: "",
        align: "center",
        headerAlign: "center",
        sortable: false,
        maxWidth: 5,
        fontsize: "10px",
        renderCell: ( par : any) => {
          let idd: string = par?.row?.id;
          return (
            <Box display={"flex"} justifyContent={"center"}>
          <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: 'green',    // متن قرمز
                }}
                variant="text"
                startIcon={<GridCheckCircleIcon/>}
                onClick={() => {
                  setHistoryModal(true);
                  setKrId(idd);
                }}
          >
          </Button>
         </Box>
          )
        },
      },
    
  ],[]);

  const initialSubmitForm: any = (data: any): any => {
    data.objectId = kresultId;
    data.okrStateId = okrStateId;
    addCheck(data)
  }

  useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

  return (
    <>
    <Grid container  spacing={1} >    
      <Grid item xs={12}>
      <DyDataGridCustom
        rowHeight={10}
        data={historyDataLoading ? []: historyData}
        columns={tenantsColumns || []}
        hideFooter={false}
        additionalToolbar={false}
        setSelectionModel={setIndexSelectionModel}
        setShowHistory={() =>{}}
        initialOnRowClick={setKrRowData}
        setSpecialId={setKrId}
        initialDelete={() =>{}}
        setSelectedIds={setIds}
     />
      </Grid>
      </Grid>
    {createTenantModal && (
        <ModalLyt
          title={"ایجاد"}
          showModal={Boolean(createTenantModal)}
          setShowModal={setCreateTenantModal}
        >
          <CreateKrAction
            hideModal={setCreateTenantModal}
            setShowToastMessage2={setShowToastMessage2}
            profileTenantId={profileTenantId}
            krDetail={krDetail}
            objective={objective}
            onSuccess={getAgain1}
            onClose={setCreateTenantModal}
            onSucces={setCreateTenantModal}
          />
        </ModalLyt>
      )}
       {historyModal && (
          <ModalLyt
            width={isMobile ? '350px' : '800px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ارزیابی"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <CreateCommitments
              objective={objective}
              text={krRowData?.text}
              coomitId={krId}
              byAdmin={true}
              kkk={kresultId}
              setShowToastMessage1 = {setShowToastMessage1}
              onClose={setHistoryModal}
              onSuccess={setHistoryModal}
            />
          </ModalLyt>
      )}
      {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={addCheckingData?.data.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {setShowToastMessage1 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage1}
            show={showToastMessage1}
          />
        )}
    </>
  )
}

export default RelatedKrAction